import React, { FunctionComponent } from "react";
import PageLayout from "./PageLayout";
import Jumbotron from "./Jumbotron";
import NavBar from "./NavBar/NavBar";

interface IJumbotronLayoutProps {
  headerLeft: JSX.Element | null;
  headerRight: JSX.Element | null;
  iconPath: string | null;
  title: string | null;
  upperLongButton?: JSX.Element | null;
  lowerLongButton?: JSX.Element | null;
  content: JSX.Element | null;
}
const JumbotronLayout: FunctionComponent<IJumbotronLayoutProps> = ({
  title,
  iconPath,
  headerLeft,
  headerRight,
  upperLongButton,
  lowerLongButton,
  content,
}: IJumbotronLayoutProps) => (
  <PageLayout
    navBar={<NavBar left={headerLeft} right={headerRight} />}
    header={<Jumbotron header={title} imageUrl={iconPath} />}
    content={
      <div>
        {upperLongButton}
        {content}
        {lowerLongButton}
      </div>
    }
  />
);

export default JumbotronLayout;
